// @flow
import gql from 'graphql-tag'

export const REGISTRATION_FIELDS_FRAGMENT = gql`
  fragment RegistrationFields on GatheringRegistration {
    id
    gatheringId
    quantity
  }
`

export type Registration = {
  id: number,
  gatheringId: number,
  quantity: number,
}
